import { CloseOutlined, PlusOutlined } from "@ant-design/icons"
import { Form, Input, Modal, Select, FormProps, FormInstance } from "antd"
import { ChangeEvent, useEffect, useRef, useState } from "react"
import './style.scss'
import { addCategoryCar } from "../../../../../api/categoryCar/categoryCarApi"
import { useForm } from "antd/lib/form/Form"
import { getListCarCompany, ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi"
import { getCLCarLines, getCLCategoryCar, getCLTypeVehicle, getCLVehicleGroup } from "../../../../../api/selectOption/selectOptionsApi"
import { fommatSelectOption } from "../../../../../until"
import { addProductGroup } from "../../../../../api/carProductGroup/carProductGroupApi"
import { CARTYPE } from "../../../../../services/data"
interface ModalProps {
  isOpen: boolean
  onSubmitFormModal?: (iSsuccess: boolean, message?: string) => void;
  closeModal: () => void
}
const ModalCreate: React.FC<ModalProps> = ({
  isOpen,
  onSubmitFormModal, closeModal
}) => {

  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);
  const isProgrammaticSet = useRef(false);
  const carLineId = Form.useWatch("carLineId", form);

  const [cLCarLines, setCLCarLines] = useState<ISelectOption[]>([])
  const [sLCarCompany, setSLCarCompany] = useState<ISelectOption[]>([])


  const gCLCarLines = async () => {
    const result = await getCLCarLines()
    if (result?.status) {
      setCLCarLines(fommatSelectOption(result.data))
    }
  }

  // thương hiệu xe
  const gSLCarCompany = async () => {
    if (!carLineId) return
    const result = await getCLCategoryCar(
      carLineId
    )
    if (result?.status) {
      setSLCarCompany(fommatSelectOption(result.data))
    }
  }

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    const {
      code, title, carLineId,
      categoryCarId
    } = values
    const result = await addProductGroup(
      code, title, carLineId, categoryCarId
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  }

  useEffect(() => {
    if (carLineId) {
      gSLCarCompany()
    }

    if (isProgrammaticSet.current) {
      isProgrammaticSet.current = false;
      return;
    }
    form.setFieldValue("typeVehicleId", undefined);
    // }
  }, [carLineId]);

  useEffect(() => {
    if (isOpen) {
      if (!cLCarLines.length)
        gCLCarLines()
      form.setFieldValue("carLineId", CARTYPE.CAR_BUS);
    } else {
      isProgrammaticSet.current = false
      form.resetFields()
    }
  }, [isOpen]);

  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
      requiredMark={true}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">
            Tạo mới nhóm sản phẩm
          </span>
          <CloseOutlined className="text-base text-8B8B8B"
            onClick={closeModal}
          />
        </div>}
        open={isOpen}
        onCancel={closeModal}
        centered
        className="w-modal modal-content ant-modal-size"
        closeIcon={false}
        footer={
          <div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
            <span className="text-sm text-98A2B3 cursor-pointer"
              onClick={closeModal}
            >
              Huỷ
            </span>
            <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
              onClick={submitForm}>
              Lưu
            </button>
          </div>
        }
      >
        <div className="px-6 py-2 d-flex flex-column gap-2">
          <div className="d-flex gap-2 flex-column pt-2">
            <div className="d-flex flex-column gap-4">

              <Form.Item

                label={<span className="">Dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="carLineId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn dòng xe!' }]}
              >
                <Select
                  allowClear
                  disabled
                  options={cLCarLines}
                />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">

              <Form.Item
                label={<span className="">Thương hiệu<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="categoryCarId"
                className="m-none-form-item text-explan text-label"
                rules={[{ required: true, message: 'Chọn thương hiệu!' }]}
              >
                <Select
                  disabled={!carLineId}
                  allowClear
                  options={sLCarCompany}
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Nhóm sản phẩm<span className="pl-1" style={{ color: 'red' }}>*</span></span>}

                layout="vertical"
                name="code"
                rules={[{ required: true, message: 'Nhập mã nhóm!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Mã nhóm"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Tên nhóm sản phẩm<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="title"
                rules={[{ required: true, message: 'Nhập tên nhóm sản phẩm!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="nhóm sản phẩm"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
        </div>

      </Modal>
    </Form>
  )
}
export default ModalCreate
